import styled from '@emotion/styled';

/**
 * Компонент отображающий иконку  футера.
 */
export const Image = styled.img`
  align-self: center;
`;
